<template>
  <span
    :class="[
      XEUtils.filter(fileList, (r) => r.status === 'done').length > 0 && !(disabled || !enabled)
        ? 'file-list-exist'
        : '',
      disabled || !enabled ? 'ant-upload-disabled' : '',
    ]"
  >
    <a-upload
      name="file"
      class="ant-upload-wrapper"
      :multiple="multiple"
      :action="uploadAction"
      :headers="headers"
      :data="{ biz: bizPath }"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      @change="handleChange"
      :disabled="disabled || !enabled"
      :returnUrl="returnUrl"
      :showUploadList="false"
      :accept="accept"
    >
      <a-button class="action-btn" v-if="!(disabled || !enabled) && theme == 'default'">
        <a-icon type="upload" style="top: 1px" />
        <span style="margin-left: 5px">上传</span>
      </a-button>

      <!--<a-button
        v-if="!disabled && theme == 'icon'"
        style="transform: scale(0.9)"
        shape="circle"
        :icon="icon"
        :title="$t('disp.upload')"
      ></a-button>-->
    </a-upload>

    <div
      v-if="showDownload && (disabled || !enabled) && XEUtils.filter(fileList, (r) => r.status === 'done').length > 1"
      style="margin-top: 2px; margin-bottom: 4px; margin-left: -2px"
    >
      <a-button
        class="action-btn"
        v-if="XEUtils.filter(fileList, (r) => r.status === 'done').length > 1"
        @click="downloadAll()"
        style="line-height: 29px !important"
      >
        <a-icon type="download" />
        <span style="margin-left: 5px">下载</span>
      </a-button>
    </div>

    <div
      class="ant-upload-file-list"
      v-for="file in XEUtils.filter(fileList, (r) => r.status === 'done')"
      :key="file.uid"
    >
      <a-icon type="paper-clip" />

      <a target="_blank" :href="file.url" rel="noopener noreferrer" :disabled="$getLoginUser().username == 'guest'">
        <span>{{ file.name }}</span>

        <a-icon type="zoom-in" class="action enter-x" title="预览" @click.prevent="preview(file.url)" />

        <a-icon
          type="scissor"
          class="action enter-x-1"
          title="移除"
          @click.prevent="handleDelete(file.uid)"
          v-if="!(disabled || !enabled)"
        />
      </a>
    </div>
  </span>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getFileAccessHttpUrl } from '@/api/manage'

const FILE_TYPE_ALL = 'all'
const FILE_TYPE_IMG = 'image'
const FILE_TYPE_TXT = 'file'
const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
const getFileName = (path) => {
  if (path.lastIndexOf('\\') >= 0) {
    let reg = new RegExp('\\\\', 'g')
    path = path.replace(reg, '/')
  }
  return path.substring(path.lastIndexOf('/') + 1)
}
export default {
  name: 'JUpload',
  inject: ['preview'],
  data() {
    return {
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload',
      urlDownload: window._CONFIG['staticDomainURL'],
      headers: {},
      fileList: [],
      newFileList: [],
      ddsPara: '',
      icon: 'upload',
    }
  },
  props: {
    text: {
      type: String,
      required: false,
    },
    fileType: {
      type: String,
      required: false,
      default: FILE_TYPE_ALL,
    },
    /*这个属性用于控制文件上传的业务路径*/
    bizPath: {
      type: String,
      required: false,
      default: 'temp',
    },
    value: {
      type: [String, Array],
      required: false,
    },
    // update-begin- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDownload: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      // 'default' or 'icon'
      default: 'default',
    },
    /**
     * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否返回url，
     * true：仅返回url
     * false：返回fileName filePath fileSize
     */
    returnUrl: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否表示上传文件列表，
     * true：アップロードファイルリスト表示
     * false：アップロードファイルリスト非表示
     */
    showUploadList: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加可选择的文件类型
     */
    accept: {
      type: String,
      required: false,
    },
    /**
     * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否可以多选，
     * true：可多选
     * false：不可多选
     */
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal instanceof Array) {
          if (this.returnUrl) {
            this.initFileList(newVal.join(','))
          } else {
            this.initFileListArr(newVal)
          }
        } else {
          this.initFileList(newVal)
        }
      },
      immediate: false,
    },
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const dds = Vue.ls.get('DDS')
    this.headers = { 'X-Access-Token': token, DDS: dds }
    this.ddsPara = dds

    if (this.value) {
      if (this.value instanceof Array) {
        if (this.returnUrl) {
          this.initFileList(this.value.join(','))
        } else {
          this.initFileListArr(this.value)
        }
      } else {
        this.initFileList(this.value)
      }
    }
  },
  mounted() {},
  methods: {
    initFileListArr(val) {
      if (!val || val.length == 0) {
        this.fileList = []
        return
      }
      let fileList = []
      for (var a = 0; a < val.length; a++) {
        fileList.push({
          uid: uidGenerator(),
          name: val[a].fileName,
          status: 'done',
          url: val[a].filePath,
          response: {
            status: 'history',
            message: val[a].filePath,
          },
        })
      }
      this.fileList = fileList
    },
    initFileList(paths) {
      if (!paths || paths.length == 0) {
        //return [];
        // update-begin- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
        this.fileList = []
        return
        // update-end- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
      }
      let fileList = []
      let arr = paths.split(',')
      for (var a = 0; a < arr.length; a++) {
        //let url = getFileAccessHttpUrl(arr[a], this.urlDownload + '/' + this.ddsPara, 'http')
        let url = getFileAccessHttpUrl(arr[a], this.urlDownload, 'http')
        fileList.push({
          uid: uidGenerator(),
          name: getFileName(arr[a]),
          status: 'done',
          url: url,
          response: {
            status: 'history',
            message: arr[a],
          },
        })
      }
      this.fileList = fileList
    },
    handlePathChange() {
      let uploadFiles = this.fileList.filter((file) => file.status != undefined)
      let path = ''
      if (!uploadFiles || uploadFiles.length == 0) {
        path = ''
      }
      let arr = []

      for (var a = 0; a < uploadFiles.length; a++) {
        if (uploadFiles[a].status === 'done') {
          arr.push(uploadFiles[a].response.message)
        } else {
          return
        }
      }

      if (arr.length > 0) {
        path = arr.join(',')
      }
      this.$emit('change', path)
    },
    beforeUpload(file) {
      var fileType = file.type
      if (fileType === FILE_TYPE_IMG) {
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return false
        }
      } else if (fileType === FILE_TYPE_TXT) {
        if (fileType.indexOf('image') >= 0) {
          this.$message.warning('请上传文件')
          return false
        }
      }

      // 验证文件大小
      if (file.size && file.size > 102400000) {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: (
            <span>
              {this.$t('msg.file.oversize', ['100MB'])}
              <br />
              <span style="color:darkorange;">{file.name}</span>
            </span>
          ),
        })

        this.icon = 'upload'
        return false
      }

      return true
    },
    handleChange(info) {
      this.icon = 'loading'
      let fileList = info.fileList

      if (info.file.status === 'done') {
        this.icon = 'upload'

        if (info.file.response.success) {
          fileList = fileList.map((file) => {
            if (file.response) {
              let reUrl = file.response.message
              file.url = getFileAccessHttpUrl(reUrl, this.urlDownload + '/' + this.ddsPara, 'http')
            }
            return file
          })
        } else {
          this.$notification.error({
            message: this.$t('disp.error'),
            description:
              info.file.response.message.indexOf(';') < 0
                ? this.$t(info.file.response.message)
                : this.$t(info.file.response.message.split(';')[0], [
                    this.$t(info.file.response.message.split(';')[1]),
                  ]),
          })
        }
      } else if (info.file.status === 'error') {
        this.icon = 'upload'

        this.$notification.error({
          message: this.$t('disp.error'),
          description: `${info.file.name} ` + this.$t('disp.uploadFail'),
        })
      } else if (info.file.status === 'removed') {
        this.icon = 'upload'
      }

      this.fileList = fileList
      if (info.file.status === 'done' || info.file.status === 'removed') {
        if (info.file.response && !info.file.response.success) {
          XEUtils.remove(this.fileList, (file) => file.name == info.file.name)
        }

        //returnUrl为true时仅返回文件路径
        if (this.returnUrl) {
          this.handlePathChange()
        } else {
          //returnUrl为false时返回文件名称、文件路径及文件大小
          fileList = fileList
            .filter((file) => {
              if (file.response) {
                return file.response.success === true
              }
              return false
            })
            .map((file) => {
              var fileJson = {
                fileName: file.name,
                filePath: file.response.message,
                fileSize: file.size,
              }
              this.newFileList.push(fileJson)
              this.$emit('change', this.newFileList)
            })
        }
      }
    },
    handleDelete(uid) {
      XEUtils.remove(this.fileList, (r) => r.uid == uid)
      this.handlePathChange()
    },
    handleDeleteAll() {
      this.fileList = []
      this.handlePathChange()
    },
    downloadAll() {
      XEUtils.filter(this.fileList, (r) => r.status === 'done').forEach((r, index) => {
        setTimeout(() => {
          downloadFile(r.url.replaceAll(this.urlDownload, ''))
        }, 100 * index)
      })
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
}
</script>

<style scoped lang="less">
.file-list-exist .ant-upload-wrapper {
  margin-bottom: 3px;
}

.ant-upload-file-list {
  height: 22px;

  .anticon-paper-clip {
    vertical-align: 0;
  }

  a {
    margin-left: 3px;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 17px);
    top: 4px;
    height: 18px;
    position: relative;
    line-height: 1;

    &::after {
      transition: transform 0.5s !important;
      top: 17px !important;
    }

    &:hover {
      padding-right: 42px;

      .action {
        display: inherit;
      }
    }

    .anticon {
      display: none;
      right: 20px;
      position: absolute;

      &:hover {
        color: var(--color-primary-8);
      }
    }

    .anticon-scissor {
      right: 2px;

      &:hover {
        color: var(--color-red);
      }
    }
  }

  .anticon {
    color: var(--color-grey);
    transition: all 0.3s;
  }
}

.ant-upload-disabled {
  .ant-upload-file-list {
    a {
      &:hover {
        padding-right: 24px;

        .anticon {
          right: 2px;
        }
      }
    }
  }
}

.action-btn {
  min-width: unset !important;
  padding: 0px 6px 0px 6px !important;
  height: 28px !important;
  font-size: 13px !important;
  line-height: 26px !important;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
